import { theme } from '@wco/toolkit';
import { AppConfig } from './types';

const devMode = process.env.REACT_APP_ENV !== 'P';
const isLocal = window?.location.hostname === 'localhost';
const defaultImgURL = isLocal
  ? ''
  : devMode
  ? 'https://static.bankdata.dk/wco/rc/widget-fmi/' +
    process.env.REACT_APP_BANK +
    '/'
  : 'https://static.bankdata.dk/wco/release/widget-fmi/' +
    process.env.REACT_APP_BANK +
    '/';
const isServer = typeof window === 'undefined';

const appConfig: AppConfig = {
  devMode,
  apiBasePath: devMode
    ? 'https://wcm1-' +
      (theme.name === 'Nordjyskebank' ? 'landbobanken' : theme.name) +
      '-dk-s.bdunet.dk'
    : 'https://www.' + theme.root,
  SSR: isServer,
  showMobile: true,
  showFax: true,
  baseUrl: '',
  defaultImgBaseurl: defaultImgURL
};

export default appConfig;
